import React from 'react';
import '../styles/about.css'; // Ensure you create this file for the CSS

const About = () => {
    return (
        <div className="about">
            <h1>About</h1>
            <div className="about-sections">
            <div className="about-section">
                  <h2>Local Åland AI startup</h2>
                    <p>FramSys was founded in 2025 with the mission of delivering state-of-the-art AI solutions and applied technologies to businesses worldwide. Based on the scenic islands of Åland, our goal is to modernize and make AI tools accessible to everyone.</p>
                    <p>We are a small team of IT experts with expertise in both normal software stacks and AI enchanced solutions.</p>

                </div>
                <div className="about-section">
                    <h2>Easy high tech</h2>
                    <p>Our company wants to make it as easy as possible for customers to use our solutions. Whether you're looking to implement AI into your business or need tailored technology solutions, FramSys is here to help you navigate the future with confidence.</p>
                </div>
                <div className="about-section">
                    <h2>State of the art technologies</h2>
                    <p>Specializing in cutting-edge AI, machine learning, and innovative technological applications, we bring the latest advancements to help companies streamline operations, enhance decision-making, and stay competitive in an ever-evolving digital landscape.</p>
                </div>
 
                <div>
                   <img src={require('../assets/logos/FramSys_Logo2_LT.png')}     style={{ maxWidth: '100%', height: 'auto' }} alt="Framsys logo could not be displayed"/>
                </div>
            </div>
        </div>
    );
};

export default About;